import { Link } from "react-router-dom";
import { Instagram, Linkedin, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0F0F16] border-t border-white/10" data-testid="main-footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_coach-hub-96/artifacts/uwrqhh9u_1777073959823.png" 
                alt="APM Logo"
                className="h-14 w-auto invert"
              />
            </Link>
            <p className="text-[#94A3B8] max-w-md leading-relaxed">
              APM Athletics Performance Mouvement - Votre partenaire pour devenir 
              coach indépendant et atteindre 3000€/mois en 90 jours via les salles Basic-Fit.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0066FF] hover:border-[#0066FF] transition-all"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0066FF] hover:border-[#0066FF] transition-all"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0066FF] hover:border-[#0066FF] transition-all"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Outfit'] font-bold uppercase tracking-wider text-sm mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-link-home">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/coaches" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-link-coaches">
                  Nos Coachs
                </Link>
              </li>
              <li>
                <Link to="/apply" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-link-apply">
                  Rejoindre APM
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Outfit'] font-bold uppercase tracking-wider text-sm mb-6">
              Contact
            </h4>
            <ul className="space-y-3 text-[#94A3B8]">
              <li>
                <a href="mailto:floriangleize.coaching@gmail.com" className="hover:text-[#0066FF] transition-colors" data-testid="footer-email">
                  floriangleize.coaching@gmail.com
                </a>
              </li>
              <li>Fondateur : Florian GLEIZE</li>
              <li>France - Région Sud</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#64748B] text-sm">
            © 2026 APM Athletics Performance Mouvement. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-[#64748B] hover:text-white transition-colors">
              Mentions légales
            </a>
            <a href="#" className="text-[#64748B] hover:text-white transition-colors">
              Politique de confidentialité
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
